import type { WorkspaceService } from '@affine/core/modules/workspace';
import { Service } from '@toeverything/infra';

import { EmbeddingEnabled } from '../entities/embedding-enabled';
import { EmbeddingProgress } from '../entities/embedding-progress';
import { IgnoredDocs } from '../entities/ignored-docs';
import type { EmbeddingStore } from '../stores/embedding';

export class EmbeddingService extends Service {
  embeddingEnabled = this.framework.createEntity(EmbeddingEnabled);
  ignoredDocs = this.framework.createEntity(IgnoredDocs);
  embeddingProgress = this.framework.createEntity(EmbeddingProgress);

  constructor(
    private readonly workspaceService: WorkspaceService,
    private readonly store: EmbeddingStore
  ) {
    super();
  }

  /**
   * Changes the AI ignore list. The progress polling stops itself once
   * embedded === total, so it is restarted to show the new numbers.
   */
  async updateIgnoredDocs(add: string[], remove: string[]): Promise<void> {
    await this.ignoredDocs.updateIgnoredDocs({ add, remove });
    this.embeddingProgress.startEmbeddingProgressPolling();
  }

  /** Re-indexes the given docs and restarts the progress polling. */
  async reindexDocs(docIds: string[]): Promise<void> {
    await this.store.reindexWorkspace(
      this.workspaceService.workspace.id,
      docIds
    );
    this.embeddingProgress.startEmbeddingProgressPolling();
  }
}
